<template>
  <b-modal ref="modal" hide-footer title="Request Company Number Change">

    <b-row class="my-1">
      <b-col md="4">
        <label for="reason">New Number</label>
      </b-col>
      <b-col md="8">
        <b-form-input id="newNumber" v-model="newNumber"></b-form-input>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4">
        <label for="reason">Reason for Change</label>
      </b-col>
      <b-col md="8">
        <b-form-textarea id="reason" v-model="reason"></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="6"> </b-col>
      <b-col md="6">
        <b-button class="mt-3"
                  variant="success"
                  block
                  @click="sendRequest">
          <font-awesome-icon icon="check" /> Send Request
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
  props: {
    companyId: Number,
  },
  data() {
    return {
      reason: null,
      newNumber: null,
    };
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    sendRequest() {
      this.isBusy = true;

      this.$http.post("/company/requestCompanyNumberChange",
        {
          companyId: this.companyId,
          reason: this.reason,
          newNumber: this.newNumber,
        }).then(() => {
        this.isBusy = false;
        this.hideModal();
      });
    },
  },
};
</script>
